var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvite = function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#D0D0D0",
    clipPath: "url(#invite_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.811 9.469c-.092 1.239-1.031 2.25-2.062 2.25-1.032 0-1.973-1.01-2.063-2.25-.094-1.29.82-2.25 2.063-2.25 1.242 0 2.156.984 2.062 2.25"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M12.75 13.219c-2.039 0-4.108 1.125-4.491 3.248-.047.256.098.502.366.502h8.25c.268 0 .413-.246.367-.502-.383-2.123-2.453-3.248-4.492-3.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.063 10.219v2.625m1.312-1.313H6.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "invite_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6.094h12v12H6z"
  })))));
};
export default SvgInvite;